import _ from "lodash";
import moment from "moment";
import {
  BANK_LOCATION_OTHER_OPTION,
  BLOOD_GROUPS,
  CSR_CONTRIBUTION_OPTIONS,
  DECLARATION_PLACES,
  DEFAULT_BANKS,
  DEFAULT_BANK_IFSC_CODES,
  NATIONALITY,
  OTHER_OPTION,
  TITLES,
  fullTimeOrPartTime
} from "../constants/constants";

export const getAddressValue = (fieldName, addressDetails, addressType) => {
  if (addressDetails) {
    const addressObj = addressDetails.find(
      address => address.addressType === addressType
    );
    return addressObj ? addressObj[fieldName] : "";
  }
  return "";
};

export const getAddressId = (addressDetails, addressType) => {
  const addressObj = addressDetails.find(
    address => address.addressType === addressType
  );
  return addressObj ? addressObj.id : 0;
};

export const getStateName = (stateID, stateDetails = []) => {
  const stateObj = stateDetails.find(state => state.id === stateID);
  return stateObj ? stateObj.stateName : stateID;
};

export const getQualificationDetails = (
  qualificationId,
  qualificationDetails
) => {
  return qualificationDetails
    ? qualificationDetails.find(
        qualification => qualification.qualificationId === qualificationId
      )
    : {};
};

export const getRelationDetails = (relationId, relationDetails = []) => {
  const relationObj = relationDetails.find(
    relation => relation.relationShipType === relationId
  );
  return relationObj ? relationObj : {};
};

export const getRelationShipName = (relationId, relationShipDetails) => {
  const relationObj = relationShipDetails.find(
    relation => relation.id === relationId
  );
  return relationObj ? relationObj.relationShipType : "";
};

export const getNomineeData = (nomineeEntity = [], filedName, memberID) =>
  _.find(nomineeEntity, { familyMemberId: memberID })[filedName];

export const getDeclarationPlace = placeId => {
  const declarationPlaceEntity = DECLARATION_PLACES.find(
    place => place.id == placeId
  );
  return (declarationPlaceEntity && declarationPlaceEntity.name) || "";
};

export const getSelectedBankLocationOption = placeName => {
  if (placeName) {
    const declarationPlaceEntity = DECLARATION_PLACES.find(
      place => place.name == placeName
    );
    return (
      (declarationPlaceEntity && declarationPlaceEntity.id) ||
      BANK_LOCATION_OTHER_OPTION.id
    );
  }

  return placeName;
};

export const getSelectedBankNameOption = bankName => {
  if (bankName) {
    const defaultBankEntity = DEFAULT_BANKS.find(bank => bank.name == bankName);
    return (defaultBankEntity && defaultBankEntity.id) || OTHER_OPTION.id;
  }
  return bankName;
};

export const getSelectedIFSCCodeOption = bankIFSCCode => {
  if (bankIFSCCode) {
    const defaultIFSCCodeEntity = DEFAULT_BANK_IFSC_CODES.find(
      ifsc => ifsc.code == bankIFSCCode
    );

    return (
      (defaultIFSCCodeEntity && defaultIFSCCodeEntity.id) || OTHER_OPTION.id
    );
  }
  return bankIFSCCode;
};

export const getBankName = (bankNameId, otherBankName) => {
  if (otherBankName) return otherBankName;
  const defaultBankEntity = DEFAULT_BANKS.find(bank => bank.id == bankNameId);

  return (defaultBankEntity && defaultBankEntity.name) || "";
};

export const getBankIFSCCode = (bankIFSCCodeId, otherIFSCCode) => {
  if (otherIFSCCode) return otherIFSCCode;
  const defaultIFSCCodeEntity = DEFAULT_BANK_IFSC_CODES.find(
    ifsc => ifsc.id == bankIFSCCodeId
  );
  return (defaultIFSCCodeEntity && defaultIFSCCodeEntity.code) || "";
};

export const getBankLocation = (bankLocationId, otherBankLocation) => {
  if (otherBankLocation) return otherBankLocation;
  const declarationPlaceEntity = DECLARATION_PLACES.find(
    place => place.id == bankLocationId
  );

  return (declarationPlaceEntity && declarationPlaceEntity.name) || "";
};

export const getFatherOrMotherOrSpouseName = (relationId, familyMembers) => {
  const relationDetails = getRelationDetails(+relationId, familyMembers);
  return (relationDetails && relationDetails.fullName) || "";
};

export const getTitle = titleSelected => {
  const titleEntity = TITLES.find(title => title.id == titleSelected);
  return (titleEntity && titleEntity.description) || "";
};

export const getNationality = nationalitySelected => {
  const nationalityEntity = NATIONALITY.find(
    nationality => nationality.id == nationalitySelected
  );
  return (nationalityEntity && nationalityEntity.description) || "";
};

export const getBloodGroup = bloodGroupSelected => {
  const bloodGroupEntity = BLOOD_GROUPS.find(
    bloodGroup => bloodGroup.id == bloodGroupSelected
  );
  return (bloodGroupEntity && bloodGroupEntity.description) || "";
};

export const getFullTimeOrPartTime = isFullTimeQualification => {
  const selectedFullTimeOrPartTime = fullTimeOrPartTime.find(
    type => type.id === isFullTimeQualification
  );

  return (
    (selectedFullTimeOrPartTime && selectedFullTimeOrPartTime.description) ||
    "Full Time"
  );
};

export const getCSRAmount = csrAmountId => {
  if (csrAmountId) {
    const csrContributionOption = CSR_CONTRIBUTION_OPTIONS.find(
      csrOption => csrOption.id == csrAmountId
    );
    return csrContributionOption.amount;
  }
  return "0";
};

export const findTotalExperienceInDays = candidateDetails => {
  let totalExp = 0;
  const { organizationDetails } = candidateDetails;
  if (organizationDetails) {
    totalExp = organizationDetails.reduce((accumulator, org) => {
      const joinDate = moment(org.joiningDate);
      const exitDate = moment(org.lastWorkingDate);
      const days = exitDate.diff(joinDate, "days");
      return accumulator + days;
    }, 0);
  }
  return totalExp;
};

export const getNoOfYearsMonthsDaysString = diff => {
  var str = "";
  if(diff){
    var values = [
      [" Year", 365],
      [" Month", 30],
      [" Day", 1]
    ];
    for (var i = 0; i < values.length; i++) {
      var amount = Math.floor(diff / values[i][1]);
      if (amount >= 1) {
        str += amount + values[i][0] + (amount > 1 ? "s" : "") + " ";
        diff -= amount * values[i][1];
      }
    }
}
  return str;
};